<div class="funil-venda-fase-select dropdown"
    [class.with-title]="isShowTitle">
    <button class="btn btn-light dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false"
        [disabled]="disabled">

        <small class="funil-venda-fase-select-title" *ngIf="isShowTitle">
            Fase
        </small>        

        <span class="funil-venda-fase-select-label">
            <img src="../../../../../assets/img/crm/funil-venda/funil-venda-fase.png" alt="Fase do Funil de Venda">
            <span *ngIf="funilVendaFase">
                {{funilVendaFase.nomePlural}}
            </span>
            <span *ngIf="!funilVendaFase">
                Nenhum Fase
            </span>
        </span>

    </button>
    
    <div class="dropdown-menu-container">
        <div class="dropdown-menu">
            <div class="dropdown-menu-itens">
                <a class="dropdown-item" 
                    *ngIf="isShowNull"
                    [class.dropdown-item-select]="!idFunilVendaFase"
                    (click)="select(null)">
                    Nenhum Fase
                </a>
                <a *ngFor="let fase of fases" 
                    class="dropdown-item"
                    [class.dropdown-item-select]="fase.id == idFunilVendaFase"
                    (click)="select(fase)">
                    {{fase.nomePlural}}
                </a>
            </div>
        </div>        
    </div>
</div>